import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { StrategyDspCreativeType } from "@front/m19-api-client";
import {
  IBadgeComponent,
  IIcon,
  IIconComponent,
  ILabelComponent,
  IRadioComponent,
  IRadioGroupComponent,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspDealRefreshButtonComponent } from "@m19-board/dsp/dsp-media/dsp-deal-refresh-button.component";

type AwarenessMedia = StrategyDspCreativeType.STREAMING_TV | StrategyDspCreativeType.VIDEO_DEAL;

@Component({
  selector: "app-dsp-media-selector",
  imports: [
    DspDealRefreshButtonComponent,
    TranslocoDirective,
    IBadgeComponent,
    IIconComponent,
    IRadioComponent,
    IRadioGroupComponent,
    ILabelComponent,
  ],
  templateUrl: "./dsp-media-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspMediaSelectorComponent {
  readonly Media = StrategyDspCreativeType;

  readonly media = model<AwarenessMedia | undefined>(undefined);
  readonly stvAvailable = input(true);
  readonly videoDealAvailable = input(true);

  readonly options: { media: AwarenessMedia; title: string; badge: string; description: string; icon: IIcon }[] = [
    {
      media: StrategyDspCreativeType.VIDEO_DEAL,
      title: "dsp-media-selector.deals",
      badge: "dsp-media-selector.deals_badge",
      description: "dsp-media-selector.deals_description",
      icon: "monitorPlay",
    },
    {
      media: StrategyDspCreativeType.STREAMING_TV,
      title: "dsp-media-selector.brand_plus",
      badge: "dsp-media-selector.brand_plus_badge",
      description: "dsp-media-selector.brand_plus_description",
      icon: "monitorCog",
    },
  ];

  select(media?: StrategyDspCreativeType) {
    if (media === StrategyDspCreativeType.STREAMING_TV && this.stvAvailable()) {
      this.media.set(media);
    } else if (media === StrategyDspCreativeType.VIDEO_DEAL && this.videoDealAvailable()) {
      this.media.set(media);
    }
  }
}
